import React from 'react'
import classNames from 'classnames'

const InfoBlock = props => (
  <div
    className={classNames({
      'info-block': true,
      [props.className]: props.className
    })}
  >
    {props.children}
  </div>
)

export default InfoBlock



// WEBPACK FOOTER //
// ./src/ui/texts/info-block.js